<template>
  <div class="page-report">
    <HeaderMegaposData />
    <div class="page-header align-items-start min-vh-100 my-transacions">
      <span class="mask bg-white"></span>
      <div class="container">
        <div class="row">
          <div class="col-lg-12 col-md-12 col-12 mx-auto mt-4">
            <div class="row">
              <h2>Category Sales Report</h2>
            </div>
            <div class="row mt-3">
              <div class="col-lg-3 col-md-12 col-12">
                <div class="form-group">
                  <label> Branch </label>
                  <div>
                    <Multiselect
                      v-model="physicalBranchSelected"
                      :options="physicalBranches"
                      placeholder="Select Branch"
                      :canClear="false"
                    />
                  </div>
                </div>
              </div>
              <div class="col-lg-3 col-md-12 col-12">
                <div class="form-group">
                  <label> Period </label>
                  <div>
                    <Multiselect
                      v-model="filter_time"
                      :options="times"
                      placeholder="Select Period"
                      :canClear="false"
                    />
                  </div>
                </div>
              </div>
            </div>
            <div class="d-flex mt-4 export-type">
              <button
                class="dt-button buttons-html5"
                type="button"
                @click="exportCategorySales('csv')"
              >
                <span>Csv</span>
              </button>
              <button
                class="dt-button buttons-html5"
                type="button"
                @click="exportCategorySales('xlsx')"
              >
                <span>Excel</span>
              </button>
            </div>
            <div class="row mt-4">
              <div class="col-12">
                <div class="px-0 pb-2">
                  <div class="table-responsive p-0 custom-table">
                    <table class="table align-items-center mb-0">
                      <thead>
                        <tr>
                          <th class="text-center font-weight-bolder">Row No</th>
                          <th class="text-center font-weight-bolder">Category</th>
                          <th class="text-center font-weight-bolder">Qty Sold</th>
                          <th class="text-center font-weight-bolder">
                            Total Sales
                          </th>
                        </tr>
                      </thead>
                      <tbody v-if="categorySales && categorySales.length">
                        <tr v-for="(item, index) in categorySales" :key="index">
                          <td class="text-center text-xss">{{ index + 1 }}</td>
                          <td class="text-center text-xss">
                            {{ item.category_name }}
                          </td>
                          <td class="text-center text-xss">
                            {{ item.quantity }}
                          </td>
                          <td class="text-center text-xss">
                            $
                            {{
                              new Intl.NumberFormat("en", {
                                maximumFractionDigits: 2,
                                minimumFractionDigits: 2,
                              }).format(parseFloat(item.total ?? 0))
                            }}
                          </td>
                        </tr>
                      </tbody>
                      <tbody v-else class="no-data">
                        <tr>
                          <td colspan="4" class="text-center">No data</td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
            <form
              :action="`${actionDownload}/merchant/download-category-sales-report`"
              method="POST"
            >
              <input type="hidden" name="merchantId" :value="merchantIdExport" />
              <input type="hidden" name="merchant_code" :value="merchantCode" />
              <input type="hidden" name="token" :value="token" />
              <input
                type="hidden"
                name="physical_branch_id"
                :value="physicalBranchSelected"
              />
              <input type="hidden" name="time_type" :value="filter_time" />
              <input type="hidden" name="action" value="export" />
              <input
                type="hidden"
                name="action_export"
                :value="categorySalesExport"
              />
              <input
                type="hidden"
                name="checkExport"
                :value="checkExportCategory"
              />
              <input
                id="downloadCategorySalesForm"
                type="submit"
                class="d-none"
              />
            </form>
          </div>
        </div>
      </div>
      <div class="position-fixed top-1 end-1 z-index-2 message-success">
        <material-snackbar
          v-if="snackbar === 'danger' || snackbar === 'success'"
          title
          date
          :description="message"
          :icon="{ component: 'campaign', color: 'white' }"
          :color="snackbar"
          :close-handler="closeSnackbar"
        />
      </div>
      <material-loading :active="loaderActive" />
    </div>
  </div>
</template>

<script>
import Multiselect from "@vueform/multiselect";
import "bootstrap/dist/js/bootstrap.bundle";
import TokenService from "../../services/token.service";
import DashboardService from "../../services/dashboard.service";
import MaterialLoading from "@/components/MaterialLoading.vue";
import MaterialSnackbar from "@/components/MaterialSnackbar.vue";
import HeaderMegaposData from "./components/HeaderMegaposData.vue";
import $ from "jquery";

export default {
  name: "CategorySalesReport",
  components: {
    Multiselect,
    MaterialLoading,
    MaterialSnackbar,
    HeaderMegaposData,
  },
  data() {
    return {
      snackbar: null,
      message: "",
      loaderActive: false,
      filter_time: 1,
      times: [
        { value: 1, label: "Today" },
        { value: 5, label: "This month" },
        { value: 7, label: "This year" },
      ],
      categorySales: [],
      physicalBranches: [],
      physicalBranchSelected: 0,
      actionDownload: process.env.VUE_APP_BASE_URL,
      merchantIdExport: localStorage.getItem("MERCHANT_ID", ""),
      merchantCode: localStorage.getItem("MERCHANT_CODE", ""),
      token: TokenService.getLocalAccessToken(),
      categorySalesExport: 0,
      checkExportCategory: false,
    };
  },
  async created() {
    await this.getData();
  },
  methods: {
    showLoader() {
      this.loaderActive = true;
    },
    hideLoader() {
      this.loaderActive = false;
    },
    closeSnackbar() {
      this.snackbar = null;
    },
    setTimeOutNotification() {
      setTimeout(() => {
        this.snackbar = null;
      }, 3000);
    },
    async getData() {
      this.showLoader();
      await DashboardService.getData({
        physical_branch_id: this.physicalBranchSelected,
        time_type: this.filter_time,
      }).then(
        (response) => {
          if (response.data.result.isSuccess) {
            this.categorySales = response.data.data.category_sales;
            this.physicalBranches = response.data.data.physical_branches;
            this.checkExportCategory = true;
          } else {
            this.snackbar = "danger";
            this.message = response.data.result.message;
            this.setTimeOutNotification();
          }
        },
        (error) => {
          this.snackbar = "danger";
          this.message = error;
          this.setTimeOutNotification();
        }
      );
      this.hideLoader();
    },
    exportCategorySales(type = "csv") {
      this.categorySalesExport = type;
      setTimeout(() => {
        $("#downloadCategorySalesForm").click();
      }, 150);
      setTimeout(() => {
        this.categorySalesExport = 0;
      }, 500);
    },
  },
  watch: {
    async filter_time() {
      await this.getData();
    },
    async physicalBranchSelected() {
      await this.getData();
    },
  },
};
</script>

<style scoped>
label:not(.form-check-label):not(.custom-file-label) {
  font-weight: 700;
}

table thead th:not(:first-child) {
  padding-left: 10px !important;
  padding-right: 10px !important;
}

button.dt-button {
  position: relative;
  display: inline-block;
  box-sizing: border-box;
  margin-right: 0.333em;
  margin-bottom: 0.333em;
  padding: 0.5em 1em;
  border: 1px solid rgba(0, 0, 0, 0.3);
  border-radius: 2px;
  cursor: pointer;
  font-size: 0.88em;
  line-height: 1.6em;
  color: black;
  white-space: nowrap;
  overflow: hidden;
  background-color: rgba(0, 0, 0, 0.1);
  background: linear-gradient(
    to bottom,
    rgba(230, 230, 230, 0.1) 0%,
    rgba(0, 0, 0, 0.1) 100%
  );
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
  text-decoration: none;
  outline: none;
  text-overflow: ellipsis;
}

button.dt-button:hover {
  text-decoration: none;
}

button.dt-button:hover:not(.disabled) {
  border: 1px solid #666;
  background: linear-gradient(
    to bottom,
    rgba(153, 153, 153, 0.1) 0%,
    rgba(0, 0, 0, 0.1) 100%
  );
}

button.dt-button:focus:not(.disabled) {
  border: 1px solid #426c9e;
  text-shadow: 0 1px 0 #c4def1;
  outline: none;
  background: linear-gradient(to bottom, #d1e2f7 0%, #79ace9 100%);
}

tbody:not(.no-data) > tr:nth-child(2n + 1) {
  background: #f0f2f5;
}

tbody:not(.no-data) > tr:hover {
  background: #ebecee;
}

.custom-table :not(caption) > * > * {
  border-right-width: 1px !important;
}

.custom-table :not(caption) > * > *:first-child {
  border-left-width: 1px !important;
}
</style>
